import { httpPost, httpDownload } from '../../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import Moment from 'moment';
import {
    getInventoryCircuitInvoice,
    setInventoryCircuitInvoiceError,
    setInventoryCircuitInvoiceColSearchStr,
    setInventoryCircuitInvoicePageSize,
    sortInventoryCircuitInvoice,

    getInventoryCircuitDispute,
    setInventoryCircuitDisputeError,
    setInventoryCircuitDisputeColSearchStr,
    setInventoryCircuitDisputePageSize,
    sortInventoryCircuitDispute,
    setDefaultInvoiceTab
} from '../../../../constants/model-reducers/external/inventory/circuit-details/invoice/invoice.settings';
import { convertToFormatLocalDate } from '../../../../utils/helpers.utils'

const defaultState = () => ({
    isInventoryCircuitInvoiceLoaded: false,
    isInventoryCircuitInvoiceError: false,
    inventoryCircuitInvoiceItems: DEFAULT_TABLE_RESULT_MODEL,
    inventoryCircuitInvoiceIsSortedAsc: false,

    isInventoryCircuitDisputeLoaded: false,
    isInventoryCircuitDisputeError: false,
    inventoryCircuitDisputeItems: DEFAULT_TABLE_RESULT_MODEL,
    inventoryCircuitDisputeIsSortedAsc: false,

});

const initialState = defaultState();

export const inventoryCircuitInvoiceActions = {
    setDefaultInvoiceTab: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultInvoiceTab
        });
    },
    getInventoryCircuitInvoice: (circuitID, financeAccountID, pageIndex = 0) => async (dispatch, state) => {
        const { Headers, Pagination, SortedColumnName, inventoryCircuitInvoiceIsSortedAsc } = state().inventoryCircuitInvoice.inventoryCircuitInvoiceItems;
        var formData = {
            CircuitID: circuitID,
            FinanceAccountID: financeAccountID,
            PageFilter: {
                PageIndex: pageIndex !== undefined ? pageIndex : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: SortedColumnName,
            IsSortAscending: inventoryCircuitInvoiceIsSortedAsc,
            TableFilterList: [],
        };
        var circuitInvoiceItems = await httpPost('external/inventory/getCircuitInvoice', formData);
        if (circuitInvoiceItems.ok === false) {
            dispatch({
                type: setInventoryCircuitInvoiceError,
                isInventoryCircuitInvoiceError: true,
                isInventoryCircuitInvoiceLoaded: false
            });
        } else {
            dispatch({
                type: getInventoryCircuitInvoice,
                circuitInvoiceItems: Object.keys(circuitInvoiceItems).length > 0 ? circuitInvoiceItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryCircuitInvoiceLoaded: true,
                isInventoryCircuitInvoiceError: false
            });
        }
    },
    setInventoryCircuitInvoiceColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { inventoryCircuitInvoiceItems } = state().inventoryCircuitInvoice;
        var inventoryCircuitInvoiceItemsUpd = {
            ...inventoryCircuitInvoiceItems,
            "Headers": {
                ...inventoryCircuitInvoiceItems.Headers,
                [key]: {

                    ...inventoryCircuitInvoiceItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setInventoryCircuitInvoiceColSearchStr,
            data: inventoryCircuitInvoiceItemsUpd,
            isInventoryCircuitInvoiceError: false,
            isInventoryCircuitInvoiceLoaded: true
        });
    },
    sortInventoryCircuitInvoice: (columnClicked, isSortedAsc, circuitId, financeAccountId) => async (dispatch, state) => {
        const { Headers, Pagination, Data, SortedColumnName, IsSortAscending } = state().inventoryCircuitInvoice.inventoryCircuitInvoiceItems;
        const { inventoryCircuitInvoiceItems } = state().inventoryCircuitInvoice;
        var formData = {
            CircuitID: circuitId,
            FinanceAccountID: financeAccountId,
            PageFilter: {
                PageIndex: Pagination.PageNumber !== undefined ? Pagination.PageNumber : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...inventoryCircuitInvoiceItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: [],
        };
        var circuitInvoiceItems = await httpPost('external/inventory/getCircuitInvoice', formData);
            dispatch({
                type: sortInventoryCircuitInvoice,
                circuitInvoiceItems: circuitInvoiceItems ,
                isInventoryCircuitInvoiceLoaded: true,
                isInventoryCircuitInvoiceError: false
            });
    },

    extractCircuitInvoice: (circuitID, financeAccountID) => async (dispatch, state) => {
        const { Headers, Pagination, SortedColumnName, IsSortAscending } = state().inventoryCircuitInvoice.inventoryCircuitInvoiceItems;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat } = state().adminSetting;
        var filename = `ATEM Circuit Invoice – ${convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-')}`;
        var formData = {
            CircuitID: circuitID,
            FinanceAccountID: financeAccountID,
            PageFilter: {
                PageIndex: 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            FileName: filename,
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: SortedColumnName,
            IsSortAscending: IsSortAscending,
            TableFilterList: [],
        };
        httpDownload('external/inventory/getExtractCircuitInvoice', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
    getInventoryCircuitDispute: (circuitID, pageIndex = 0) => async (dispatch, state) => {
        const { Headers, Pagination, SortedColumnName, inventoryCircuitDisputeIsSortedAsc } = state().inventoryCircuitInvoice.inventoryCircuitDisputeItems;
        var formData = {
            CircuitID: circuitID,
            PageFilter: {
                PageIndex: pageIndex !== undefined ? pageIndex : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: SortedColumnName,
            IsSortAscending: inventoryCircuitDisputeIsSortedAsc,
            TableFilterList: [],
        };
        var circuitDisputeItems = await httpPost('external/inventory/getCircuitDispute', formData);
        if (circuitDisputeItems.ok === false) {
            dispatch({
                type: setInventoryCircuitDisputeError,
                isInventoryCircuitDisputeError: true,
                isInventoryCircuitDisputeLoaded: false
            });
        } else {
            dispatch({
                type: getInventoryCircuitDispute,
                circuitDisputeItems: Object.keys(circuitDisputeItems).length > 0 ? circuitDisputeItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryCircuitDisputeLoaded: true,
                isInventoryCircuitDisputeError: false
            });
        }
    },
    sortInventoryCircuitDispute: (columnClicked, isSortedAsc, circuitId) => async (dispatch, state) => {
        const { Headers, Pagination, SortedColumnName, IsSortAscending } = state().inventoryCircuitInvoice.inventoryCircuitDisputeItems;
        var formData = {
            CircuitID: circuitId,
            PageFilter: {
                PageIndex: Pagination.PageNumber !== undefined ? Pagination.PageNumber : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: [],
        };
        var circuitDisputeItems = await httpPost('external/inventory/getCircuitDispute', formData);
        dispatch({
            type: sortInventoryCircuitDispute,
            circuitDisputeItems: circuitDisputeItems,
            isInventoryCircuitDisputeLoaded: true,
            isInventoryCircuitDisputeError: false
        });
    },
    setInventoryCircuitDisputeColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { inventoryCircuitDisputeItems } = state().inventoryCircuitInvoice;
        var inventoryCircuitDisputeItemsUpd = {
            ...inventoryCircuitDisputeItems,
            "Headers": {
                ...inventoryCircuitDisputeItems.Headers,
                [key]: {

                    ...inventoryCircuitDisputeItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setInventoryCircuitDisputeColSearchStr,
            data: inventoryCircuitDisputeItemsUpd,
            isInventoryCircuitDisputeError: false,
            isInventoryCircuitDisputeLoaded: true
        });
    },

    extractCircuitDispute: (circuitID) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryCircuitInvoice.inventoryCircuitDisputeItems;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat } = state().adminSetting;
        var filename = `ATEM ${dealName.toUpperCase()} Circuit Dispute – ${convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-')}`;
        var formData = {
            CircuitID: circuitID,
            PageFilter: {
                PageIndex: 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            FileName: filename,
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: '',
            TableFilterList: [],
        };
        httpDownload('external/inventory/getExtractCircuitDispute', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {   
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInventoryCircuitInvoice:
            return {
                ...state,
                inventoryCircuitInvoiceItems: action.circuitInvoiceItems,
                isInventoryCircuitInvoiceLoaded: action.isInventoryCircuitInvoiceLoaded,
                isInventoryCircuitInvoiceError: action.isInventoryCircuitInvoiceError
            };
        case setInventoryCircuitInvoiceError:
            return {
                ...state,
                isInventoryCircuitInvoiceError: action.isInventoryCircuitInvoiceError,
                isInventoryCircuitInvoiceLoaded: action.isInventoryCircuitInvoiceLoaded
            }
        case setInventoryCircuitInvoiceColSearchStr:
            return {
                ...state,
                inventoryCircuitInvoiceItems: action.data,
                isInventoryCircuitInvoiceLoaded: action.isInventoryCircuitInvoiceLoaded,
                isInventoryCircuitInvoiceError: action.isInventoryCircuitInvoiceError
            }
        case setInventoryCircuitInvoicePageSize:
            return {
                ...state,
                inventoryCircuitInvoiceItems: {
                    ...state.inventoryCircuitInvoiceItems,
                    Pagination: {
                        ...state.inventoryCircuitInvoiceItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case sortInventoryCircuitInvoice:
            return {
                ...state,
                inventoryCircuitInvoiceItems: action.circuitInvoiceItems,
                isInventoryCircuitInvoiceLoaded: action.isInventoryCircuitInvoiceLoaded
            }
        case getInventoryCircuitDispute:
            return {
                ...state,
                inventoryCircuitDisputeItems: action.circuitDisputeItems,
                isInventoryCircuitDisputeLoaded: action.isInventoryCircuitDisputeLoaded,
                isInventoryCircuitDisputeError: action.isInventoryCircuitDisputeError
            };
        case setInventoryCircuitDisputeError:
            return {
                ...state,
                isInventoryCircuitDisputeError: action.isInventoryCircuitDisputeError,
                isInventoryCircuitDisputeLoaded: action.isInventoryCircuitDisputeLoaded
            }
        case setInventoryCircuitDisputeColSearchStr:
            return {
                ...state,
                inventoryCircuitDisputeItems: action.data,
                isInventoryCircuitDisputeLoaded: action.isInventoryCircuitDisputeLoaded,
                isInventoryCircuitDisputeError: action.isInventoryCircuitDisputeError
            }
        case setInventoryCircuitDisputePageSize:
            return {
                ...state,
                inventoryCircuitDisputeItems: {
                    ...state.inventoryCircuitDisputeItems,
                    Pagination: {
                        ...state.inventoryCircuitDisputeItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case sortInventoryCircuitDispute:
            return {
                ...state,
                inventoryCircuitDisputeItems: action.circuitDisputeItems,
                isInventoryCircuitDisputeLoaded: action.isInventoryCircuitDisputeLoaded
            }
        case setDefaultInvoiceTab:
            return initialState;
        default:
            return state;
    }
};